import { useState, useEffect } from 'react';
import { useAuthContext } from './AuthProvider';
import AppSidebar from './AppSidebar';
import { useBillingData, fetchBillingIfStale } from '../stores';
import './UniversalLayout.css';

/**
 * Universal layout wrapper for all pages (authenticated and unauthenticated)
 * Provides sidebar navigation for all users
 */
export function UniversalLayout({ children, hideSidebar = false }) {
  const { user } = useAuthContext();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const stored = localStorage.getItem('sidebar-collapsed');
    return stored === 'true';
  });

  const { data: billing, hasCache: hasBillingCache } = useBillingData(user?.id);

  useEffect(() => {
    localStorage.setItem('sidebar-collapsed', String(sidebarCollapsed));
  }, [sidebarCollapsed]);

  useEffect(() => {
    if (!user?.id) return;
    fetchBillingIfStale({ userId: user.id });
  }, [user?.id]);

  const handleToggleCollapse = () => {
    setSidebarCollapsed(prev => !prev);
  };

  const hasPaymentMethod = Boolean(billing?.hasBilling);
  const creditBalanceCents = billing?.creditBalanceCents ?? null;
  const billingMode = billing?.billingMode ?? null;

  return (
    <div className="universal-layout">
      {!hideSidebar && (
        <AppSidebar
          collapsed={sidebarCollapsed}
          onToggleCollapse={handleToggleCollapse}
          hasPaymentMethod={hasPaymentMethod}
          billingChecked={hasBillingCache}
          isAuthenticated={Boolean(user)}
          creditBalanceCents={creditBalanceCents}
          billingMode={billingMode}
        />
      )}
      <main className="universal-layout__content">
        {children}
      </main>
    </div>
  );
}

export default UniversalLayout;
